import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  standalone: false,
  templateUrl: './connect-airbnb-official-flow.component.html',
  styleUrls: ['./connect-airbnb-official-flow.component.scss'],
})
export class ConnectAirbnbOfficialFlowComponent implements OnInit {
  stage = 1;
  airbnbOauthUrl: string;
  login: string = null;

  constructor(private readonly route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.airbnbOauthUrl = atob(params.get('encodedUrl'));
      this.login = params.get('login');
    });
  }

  startOauthFlow() {
    window.location.href = this.airbnbOauthUrl;
  }
}
